module.exports = __webpack_public_path__ + "static/media/blog_grid_5.b8f64ea7.jpg";